<template>
    <field-wrapper
        id="customerDeliveryAddress"
        :label-text="texts.label"
        :error-text="errorMessage"
        :show-error="Boolean(errorMessage)"
    >
        <input-text
            id="customerDeliveryAddress_input"
            v-model="value"
            type="text"
            autocomplete="street-address"
            aria-describedby="customerDeliveryAddress_error"
            :aria-invalid="errorMessage ? 'true' : 'false'"
        />
    </field-wrapper>
</template>

<script>
import FieldWrapper from "@/components/elements/FieldWrapper";
import InputText from "@/components/inputs/InputText";

import { mapGetters, mapMutations } from "vuex";

export default {
    components: {
        FieldWrapper,
        InputText
    },
    props: {
        validate: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        texts() {
            return this.$t("field_customer_delivery_address");
        },
        value: {
            get() {
                return this.address || "";
            },
            set(deliveryAddress) {
                this.updateCustomer({ deliveryAddress });
            }
        },
        errorMessage() {
            if (this.validate && this.error)
                return this.$t(
                    `field_customer_delivery_address.${this.error}`,
                    1,
                    {
                        invalidChars: this.invalidChars.join("")
                    }
                );
            return null;
        },
        ...mapGetters({
            address: "customer/getDeliveryAddress",
            invalidChars: "customer/getDeliveryAddressInvalidChars",
            error: "customer/getDeliveryAddressError"
        })
    },
    methods: {
        ...mapMutations({
            updateCustomer: "customer/updateCustomer"
        })
    }
};
</script>
